const CONFIG = {
  CRS_CONSUMER_CONSENT_SERVICE:
    'https://profile-test.chase.com',
};

export default CONFIG;
